module.exports = __webpack_public_path__ + "img/w3_chevron_down_white.85633abf.png";